import * as React from 'react'
import { NewMessageFileFieldConnected } from './NewMessageFileFieldConnected'
import { Provider } from 'react-redux'
import { mockState, createMockStore } from 'mockState'

export const NewMessageFileFieldExamples = () => {
  return (
    <div className="NewMessageFileFieldExamples exampleContainer">
      <h1 className="exampleHeader">default</h1>

      <Provider store={createMockStore(mockState)}>
        <NewMessageFileFieldConnected />
      </Provider>
    </div>
  )
}
